var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'form-group',
    { 'form-group--no-margin': _vm.noMargin },
    { 'form-group--visible': _vm.isVisible }
  ]},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onVisibilityChange),expression:"onVisibilityChange"}],staticClass:"visibility-sensor"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }